<template>
  <div class="user-index">
    <div class="side-bar">
      <side-button-bar>
        <div class="buttons">
          <router-link
            class="side-button"
            tag="button"
            to="/user/userInfo"
            active-class="active"
          >
            个人信息
          </router-link>
          <router-link
            class="side-button"
            tag="button"
            to="/user/myAccount"
            active-class="active"
          >
            我的账户
          </router-link>
          <my-dropdown class="drop-down">
            <template slot="title">
              <button
                :class="{ 'side-button': true, show: collectionShow }"
                @click="handleCollectionShow"
              >
                我的收藏
                <img class="img" src="@/assets/images/userPage/up.png" />
              </button>
            </template>
            <template slot="content">
              <div class="dropdown-content" v-if="hasCollection">
                <router-link
                  class="side-button-inner"
                  tag="button"
                  active-class="active"
                  v-for="item in myCollection"
                  :to="{path: '/user/myCollection/' + item.text, query: {storeId: item.id} }"
                  :key="item.id"
                >
                  <span class="collection-text">{{ item.text }}</span>
                  <div class="delete-collect">
                    <i class="el-icon-delete" @click="deleCollections(item)" title="删除收藏夹"></i>
                  </div>
                </router-link>
              </div>
              <div v-else class="no-collection">
                <span>暂未创建收藏夹</span>
              </div>
            </template>
          </my-dropdown>

          <router-link
            class="side-button"
            tag="button"
            to="/user/myNote"
            active-class="active"
          >
            我的笔记
          </router-link>
          <router-link
            class="side-button"
            tag="button"
            to="/user/viewHistory"
            active-class="active"
          >
            浏览记录
          </router-link>
        </div>
      </side-button-bar>
    </div>
    <div class="main-content">
      <router-view></router-view>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearHistory"
    >
      确认删除该收藏夹？
    </my-dialog>
  </div>
</template>

<script>
import MyDropdown from '../../components/MyDropdown.vue'
import SideButtonBar from '../../components/SideButtonBar.vue'
import MyDialog from '../../components/MyDialog.vue'
import { Message } from "element-ui"
export default {
  name: 'UserIndex',
  components: {
    MyDropdown,
    SideButtonBar,
    MyDialog
  },
  data () {
    return {
      dialogVisible: true,
      myCollection: [],
      collectionShow: false,
      hasCollection: true
    }
  },
  methods: {
    handleCollectionShow () {
      this.collectionShow = !this.collectionShow
      if (this.collectionShow) {
        // 获取收藏夹列表
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/store/getAllStores?userId=' + userId
        this.$http.get(url).then(res => {
          console.log('收藏夹信息', res.data)
          for (let i in res.data.data) {
            let tmp = res.data.data[i]
            let col = {
              id: tmp.store.id,
              text: tmp.store.storeName,
              totalcount: tmp.bookTotalCount
            }
            this.myCollection.push(col)
          }
          if(this.myCollection.length === 0) {
            this.hasCollection = false
            Message({
              type: 'warning',
              message: '暂未创建收藏夹',
            })
          }
        })
          .catch(err => {
            console.log('获取收藏夹失败', err)
          })
      } else {
        this.collectionShow = []
      }
    },
    chooseCollect (item) {
      this.$router.getCollect()
    },
    //删除收藏夹
    deleCollections(item) {
      this.$refs.messageDialog.open(() => {
        console.log(item)
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/store/deleteStoreByName?userId=' + userId + '&storeName=' + item.text
        this.$http.post(url).then(res => {
          this.myCollection = this.myCollection.filter(t => t.id !== item.id)
          // console.log(res)
           Message({
            type: 'success',
            message: '删除收藏夹成功!',
          })
          this.$router.push('/user/userinfo')
        })
        .catch(err => {
          // console.log(err)
          Message({
            type: 'error',
            message: '删除收藏夹失败!',
          })
        })
      })
    },
    clearHistory () {
      this.$refs.messageDialog.close()
    }
  }
}
</script>

<style scoped>
.user-index {
  width: 1200px;
  margin: auto;
  padding-bottom: 52px;
  display: flex;
}

.side-bar {
  height: 810px;
}

.buttons {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.side-button {
  color: #634c37;
  background-color: #ecded1;
  height: 40px;
  border: none;
  border-bottom: 2px solid #ddc4ac;
  font-weight: bold;
  text-align: left;
  padding-left: 24px;
  margin: 1px 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.my-dropdown-title .side-button {
  width: 100%;
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.side-button.active {
  color: #fff;
  background-color: #9e5c1d;
}

.side-button-inner {
  height: 40px;
  background-color: transparent;
  border: none;
  text-align: left;
  margin-left: 22px;
  cursor: pointer;
  position: relative;
}

.side-button-inner.active {
  color: #9e5c1d;
}
.delete-collect {
  display: none;
}
.side-button-inner:hover .delete-collect{
  display: block;
  position: absolute;
  top: 7px;
  left: 170px;
  height: 40px;
  color: #9e5c1d;
}

.collection-text::before {
  display: inline-block;
  content: " ";
  width: 8px;
  height: 8px;
  /* transform: rotateZ(45deg) translate(-4px, 0); */
  background-color: #634c37;
  margin-right: 10px;
}

.main-content {
  margin-left: 18px;
  flex: 1 1 auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 810px;
  overflow: scroll;
  overflow-x: hidden;
}
.no-collection {
  height: 60px;
  background-color: white;
  color: gray;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  line-height: 60px;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.img {
  width: 16px;
  margin-right: 20px;
  position: relative;
  top: -2px;
  transition: all 0.3s;
}
.img2 {
  width: 16px;
  margin-right: 20px;
  position: relative;
  top: -2px;
  transition: all 0.3s;
  transform-origin: center;
  transform: rotateZ(180deg);
}
.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}

.side-button.show .img {
  transform: rotateZ(180deg) translate(0, -5px);
}
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue